'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onlyBotMessagesAreInitialMessages = undefined;

var _reduce = require('transmute/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _messageTypeComparators = require('../../pubnub-message/operators/messageTypeComparators');

var _isFromBot = require('../../pubnub-message/operators/isFromBot');

var _hasMessages = require('../../thread-history/operators/hasMessages');

var _getMessages = require('../../thread-history/operators/getMessages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onlyBotMessagesAreInitialMessages = exports.onlyBotMessagesAreInitialMessages = function onlyBotMessagesAreInitialMessages(history) {
  if (!(0, _hasMessages.hasMessages)(history)) {
    return false;
  }

  return (0, _reduce2.default)(true, function (allBotMessagesAreInitialMessages, message) {
    if (!allBotMessagesAreInitialMessages) {
      return allBotMessagesAreInitialMessages;
    }

    return !(0, _isFromBot.isFromBot)(message) || (0, _messageTypeComparators.isInitialMessage)(message);
  }, (0, _getMessages.getMessages)(history));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/onlyBotMessagesAreInitialMessages.js
// module id = 1079
// module chunks = 2 3